/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Branch
 */
export interface Branch {
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Branch
     */
    image: string;
}

/**
 * Check if a given object implements the Branch interface.
 */
export function instanceOfBranch(value: object): value is Branch {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('image' in value) || value['image'] === undefined) return false;
    return true;
}

export function BranchFromJSON(json: any): Branch {
    return BranchFromJSONTyped(json, false);
}

export function BranchFromJSONTyped(json: any, ignoreDiscriminator: boolean): Branch {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'image': json['image'],
    };
}

export function BranchToJSON(json: any): Branch {
    return BranchToJSONTyped(json, false);
}

export function BranchToJSONTyped(value?: Branch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'image': value['image'],
    };
}

